import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3 d-flex align-items-center gap-3"
}
const _hoisted_2 = {
  class: "text-white text-capitalize mb-0",
  style: {"min-width":"140px"}
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  class: "text-silver",
  style: {"font-size":"0.85rem"}
}
const _hoisted_5 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_6 = { class: "text-white text-capitalize d-block mb-1" }
const _hoisted_7 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_8 = ["value", "onInput"]
const _hoisted_9 = {
  class: "btn btn-sm mb-0",
  style: {"cursor":"pointer","white-space":"nowrap"}
}
const _hoisted_10 = ["onChange"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_14 = { class: "text-white fw-bold text-capitalize" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "text-silver small d-block mb-1 text-capitalize" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  class: "text-silver",
  style: {"font-size":"0.85rem"}
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_23 = ["value", "onInput"]
const _hoisted_24 = {
  class: "btn btn-sm mb-0",
  style: {"cursor":"pointer","white-space":"nowrap"}
}
const _hoisted_25 = ["onChange"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "d-flex justify-content-between align-items-center mb-1" }
const _hoisted_29 = {
  class: "text-silver",
  style: {"font-size":"0.8rem"}
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "d-flex align-items-center gap-1"
}
const _hoisted_32 = {
  class: "text-silver",
  style: {"font-size":"0.75rem"}
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["value", "onInput", "placeholder"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 3,
  class: "d-flex flex-column gap-1"
}
const _hoisted_37 = ["value", "onInput"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["value", "onInput"]
const _hoisted_40 = ["value", "onInput"]
const _hoisted_41 = ["value", "onInput"]
const _hoisted_42 = {
  key: 3,
  class: "mb-4"
}
const _hoisted_43 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_44 = { class: "text-white fw-bold text-capitalize" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["value", "onInput"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 4,
  class: "mb-3"
}
const _hoisted_49 = { class: "text-white text-capitalize d-block mb-1" }
const _hoisted_50 = ["value", "onInput"]
const _hoisted_51 = {
  key: 5,
  class: "mb-3"
}
const _hoisted_52 = { class: "text-white text-capitalize d-block mb-1" }
const _hoisted_53 = ["value", "onInput"]
const _hoisted_54 = {
  key: 6,
  class: "mb-3"
}
const _hoisted_55 = { class: "text-white text-capitalize d-block mb-1" }
const _hoisted_56 = ["value", "onInput"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (value, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
        (typeof value === 'boolean')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.formatKey(key)), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["cfe-toggle", { active: value }]),
                onClick: ($event: any) => (_ctx.setField(key, !value))
              }, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "cfe-knob" }, null, -1)
              ]), 10, _hoisted_3),
              _createElementVNode("span", _hoisted_4, _toDisplayString(value ? 'Yes' : 'No'), 1)
            ]))
          : (typeof value === 'string' && _ctx.isImageField(String(key)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.formatKey(key)), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("input", {
                    value: value,
                    onInput: ($event: any) => (_ctx.setField(key, ($event.target as HTMLInputElement).value)),
                    type: "text",
                    class: "form-control bg-dark text-white border-secondary",
                    placeholder: "Paste URL or upload →"
                  }, null, 40, _hoisted_8),
                  _createElementVNode("label", _hoisted_9, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "border-style" }, "Upload", -1)),
                    _createElementVNode("input", {
                      type: "file",
                      class: "d-none",
                      accept: "image/*",
                      onChange: ($event: any) => (_ctx.uploadField($event, (url) => _ctx.setField(key, url)))
                    }, null, 40, _hoisted_10)
                  ])
                ]),
                value
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: value,
                      class: "mt-2 rounded",
                      style: {"max-height":"100px","max-width":"220px","object-fit":"cover","display":"block"}
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.isObjArray(value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.formatKey(key)), 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm",
                      onClick: ($event: any) => (_ctx.addItem(key as string))
                    }, _cache[2] || (_cache[2] = [
                      _createElementVNode("span", { class: "border-style" }, "+ Add", -1)
                    ]), 8, _hoisted_15)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((value as any[]), (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "border border-secondary rounded p-3 mb-3 position-relative"
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "cfe-remove-btn",
                        onClick: ($event: any) => (_ctx.removeItem(key as string, idx))
                      }, "✕", 8, _hoisted_16),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (fv, fk) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: fk,
                          class: "mb-2"
                        }, [
                          _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.formatKey(fk)), 1),
                          (typeof fv === 'boolean')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["cfe-toggle", { active: fv }]),
                                  onClick: ($event: any) => (_ctx.setNested(key as string, idx, fk as string, !fv))
                                }, _cache[3] || (_cache[3] = [
                                  _createElementVNode("div", { class: "cfe-knob" }, null, -1)
                                ]), 10, _hoisted_19),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(fv ? 'Yes' : 'No'), 1)
                              ]))
                            : (_ctx.isImageField(String(fk)))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("input", {
                                      value: fv,
                                      onInput: ($event: any) => (_ctx.setNested(key as string, idx, fk as string, ($event.target as HTMLInputElement).value)),
                                      type: "text",
                                      class: "form-control form-control-sm bg-dark text-white border-secondary",
                                      placeholder: "Paste URL or upload →"
                                    }, null, 40, _hoisted_23),
                                    _createElementVNode("label", _hoisted_24, [
                                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "border-style" }, "Upload", -1)),
                                      _createElementVNode("input", {
                                        type: "file",
                                        class: "d-none",
                                        accept: "image/*",
                                        onChange: ($event: any) => (_ctx.uploadField($event, (url) => _ctx.setNested(key as string, idx, fk as string, url)))
                                      }, null, 40, _hoisted_25)
                                    ])
                                  ]),
                                  fv
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: fv,
                                        class: "mt-1 rounded",
                                        style: {"max-height":"80px","max-width":"180px","object-fit":"cover","display":"block"}
                                      }, null, 8, _hoisted_26))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_ctx.isObjArray(fv))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("span", _hoisted_29, _toDisplayString((fv as any[]).length) + " item(s)", 1),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "cfe-mini-btn",
                                        onClick: ($event: any) => (_ctx.addSubItem(key as string, idx, fk as string, fv as any[]))
                                      }, "+ Add", 8, _hoisted_30)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((fv as any[]), (sv, si) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: si,
                                        class: "d-flex gap-1 align-items-center mb-1 flex-wrap"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sv, (svv, svk) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, { key: svk }, [
                                            (typeof svv === 'boolean')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.formatKey(svk)), 1),
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["cfe-toggle cfe-toggle-sm", { active: svv }]),
                                                    onClick: ($event: any) => (_ctx.setDeep(key as string, idx, fk as string, si, svk as string, !svv))
                                                  }, _cache[5] || (_cache[5] = [
                                                    _createElementVNode("div", { class: "cfe-knob" }, null, -1)
                                                  ]), 10, _hoisted_33)
                                                ]))
                                              : (_openBlock(), _createElementBlock("input", {
                                                  key: 1,
                                                  value: svv,
                                                  onInput: ($event: any) => (_ctx.setDeep(key as string, idx, fk as string, si, svk as string, ($event.target as HTMLInputElement).value)),
                                                  type: "text",
                                                  class: "form-control form-control-sm bg-dark text-white border-secondary",
                                                  placeholder: String(svk),
                                                  style: {"flex":"1","min-width":"80px"}
                                                }, null, 40, _hoisted_34))
                                          ], 64))
                                        }), 128)),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "cfe-mini-btn cfe-mini-danger",
                                          onClick: ($event: any) => (_ctx.removeSubItem(key as string, idx, fk as string, si))
                                        }, "✕", 8, _hoisted_35)
                                      ]))
                                    }), 128))
                                  ]))
                                : (Array.isArray(fv) && !_ctx.isObjArray(fv))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((fv as string[]), (sv, si) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: si,
                                          class: "d-flex gap-1"
                                        }, [
                                          _createElementVNode("input", {
                                            value: sv,
                                            onInput: ($event: any) => (_ctx.setNestedStr(key as string, idx, fk as string, si, ($event.target as HTMLInputElement).value)),
                                            type: "text",
                                            class: "form-control form-control-sm bg-dark text-white border-secondary flex-grow-1"
                                          }, null, 40, _hoisted_37),
                                          _createElementVNode("button", {
                                            class: "cfe-mini-btn cfe-mini-danger",
                                            onClick: ($event: any) => (_ctx.removeNestedStr(key as string, idx, fk as string, si))
                                          }, "✕", 8, _hoisted_38)
                                        ]))
                                      }), 128))
                                    ]))
                                  : (typeof fv === 'string' && fv.length > 80)
                                    ? (_openBlock(), _createElementBlock("textarea", {
                                        key: 4,
                                        value: fv,
                                        onInput: ($event: any) => (_ctx.setNested(key as string, idx, fk as string, ($event.target as HTMLTextAreaElement).value)),
                                        rows: "3",
                                        class: "form-control form-control-sm bg-dark text-white border-secondary"
                                      }, null, 40, _hoisted_39))
                                    : (typeof fv === 'number')
                                      ? (_openBlock(), _createElementBlock("input", {
                                          key: 5,
                                          value: fv,
                                          onInput: ($event: any) => (_ctx.setNested(key as string, idx, fk as string, Number(($event.target as HTMLInputElement).value))),
                                          type: "number",
                                          class: "form-control form-control-sm bg-dark text-white border-secondary"
                                        }, null, 40, _hoisted_40))
                                      : (_openBlock(), _createElementBlock("input", {
                                          key: 6,
                                          value: fv,
                                          onInput: ($event: any) => (_ctx.setNested(key as string, idx, fk as string, ($event.target as HTMLInputElement).value)),
                                          type: "text",
                                          class: "form-control form-control-sm bg-dark text-white border-secondary"
                                        }, null, 40, _hoisted_41))
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
              : (Array.isArray(value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.formatKey(key)), 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-sm",
                        onClick: ($event: any) => (_ctx.addStringItem(key as string))
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("span", { class: "border-style" }, "+ Add", -1)
                      ]), 8, _hoisted_45)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((value as any[]), (item, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "d-flex gap-2 mb-2"
                      }, [
                        _createElementVNode("input", {
                          value: item,
                          onInput: ($event: any) => (_ctx.setStringArray(key as string, idx, ($event.target as HTMLInputElement).value)),
                          type: "text",
                          class: "form-control form-control-sm bg-dark text-white border-secondary flex-grow-1"
                        }, null, 40, _hoisted_46),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm",
                          onClick: ($event: any) => (_ctx.removeItem(key as string, idx))
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("span", { class: "border-style" }, "✕", -1)
                        ]), 8, _hoisted_47)
                      ]))
                    }), 128))
                  ]))
                : (typeof value === 'number')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.formatKey(key)), 1),
                      _createElementVNode("input", {
                        value: value,
                        onInput: ($event: any) => (_ctx.setField(key, Number(($event.target as HTMLInputElement).value))),
                        type: "number",
                        class: "form-control bg-dark text-white border-secondary"
                      }, null, 40, _hoisted_50)
                    ]))
                  : (typeof value === 'string' && value.length > 80)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.formatKey(key)), 1),
                        _createElementVNode("textarea", {
                          value: value,
                          onInput: ($event: any) => (_ctx.setField(key, ($event.target as HTMLTextAreaElement).value)),
                          rows: "3",
                          class: "form-control bg-dark text-white border-secondary"
                        }, null, 40, _hoisted_53)
                      ]))
                    : (typeof value === 'string')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.formatKey(key)), 1),
                          _createElementVNode("input", {
                            value: value,
                            onInput: ($event: any) => (_ctx.setField(key, ($event.target as HTMLInputElement).value)),
                            type: "text",
                            class: "form-control bg-dark text-white border-secondary"
                          }, null, 40, _hoisted_56)
                        ]))
                      : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}